export default "__VITE_PUBLIC_ASSET__68d767bd__"